"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveFilterChips = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ActiveFilterChips = ({ filters, optionsMap, onRemoveFilter, }) => {
    const chips = (0, react_1.useMemo)(() => {
        const result = [];
        Object.keys(filters).forEach((key) => {
            if (!optionsMap[key]?.length)
                return;
            filters[key]?.forEach((value) => {
                const label = optionsMap[key].find((o) => o.value === value)?.label || value;
                result.push({ key, value, label });
            });
        });
        return result;
    }, [filters, optionsMap]);
    if (chips.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-wrap gap-2 mb-2", children: chips.map((chip, idx) => {
            const isMachine = chip.key === 'machines';
            const bgClass = isMachine ? 'bg-blue-100' : 'bg-customBlue';
            const textClass = isMachine ? 'text-customBlue' : 'text-blue-100';
            return ((0, jsx_runtime_1.jsxs)("span", { className: `${bgClass} ${textClass} text-xs px-2 py-1 rounded-full flex items-center gap-1`, children: [chip.label, (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => onRemoveFilter(chip.key, chip.value), className: `${textClass} hover:opacity-80 font-bold`, children: "\u00D7" })] }, idx));
        }) }));
};
exports.ActiveFilterChips = ActiveFilterChips;
